import { UsersProfileTypes } from "./usersProfileTypes";


export const initialState:UsersProfileTypes = {
  fetching: false,
  message: null,
  error: null,
  success: null,
  statusCode: null,
  panFetching: false,
  panMessage: null,
  panError: null,
  panSuccess: null,
  isPanNo: null,
  statusCodeAadhaar: null,
  statusCodePan: null,
  aadhaarFetching: false,
  aadhaarSuccess: null,
  aadhaarMessage: null,
  aadhaarError: null,
  isAadhaarNo: null,
  statusCodePassport: null,
  statusCodeUan: null,
  passportFetching: false,
  passportSuccess: null,
  passportMessage: null,
  passportError: null,
  isPassportNo: null,
  uanFetching: false,
  uanSuccess: null,
  uanMessage: null,
  uanError: null,
  isUanNo: null,
}